<template>
<div class="container-fluid">

    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

<div v-if="type=='A'" class="page-header_">

<div v-if="spinner" class="spinner-grow spinner-grow-sm text-center" role="status">
  <span class="sr-only">Loading...</span>
</div>

    <div class="row">
      
      <!--<productCollections class="ml-4" v-bind:productId="productId"></productCollections>-->

      <!-- SIZES LIST-->  
      <sizes-list v-if="refresh" v-bind:selection="sizes" @update="setSizes"></sizes-list>

      <!-- NEW COLOR -->
      <NewColor class="ml-4"></NewColor>

    </div>
    
    <form   v-on:submit.prevent="submit()">
     <div class="table-responsive-sm">       
      <table class="table table-bordered table-hover  table-sm mb-0 mt-4 my-table">
         
        <thead class="thead-light">
          
            <tr class="header-measures">
                                        
            <th class="text-center" :colspan="sizes.length+5" style="background_:#f8f9fa; font-weight:bold;">

                  <h4 style="color:black">MODIFICA QUANTITA' VARIANTI PRODOTTO ORDINE  </h4>
                  <product-info v-bind:productId="productId"></product-info>             

            </th>            
            
          </tr>
          <tr class="header-measures">
            <th></th><th></th> <th></th><th></th>                                 
            <th class="text-center" :colspan="sizes.length" style="background_:#f8f9fa; font-weight:bold;">MISURE</th>            
            <th :style="{ width:  'auto' }" class="text-right"></th>
          </tr>

          <tr>           
                <th  :style="{ width:  '100px' }">RIGA</th>
                <th  :style="{ width:  'auto' }" class="sticky-col_ sticky-color_">COLORE</th>
                <th  :style="{ width:  'auto' }"class="sticky-col_ sticky-desc_">COLORE FORNITORE</th>
                <th  :style="{ width:  'auto' }"class="sticky-col_ sticky-desc_">TIPO RIGA</th>
                 <th v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center sticky-col" :style="{ width:  'auto_' }">
              {{ size.size }}
              <button v-if="false" class="btn btn-sm btn-danger ml-1" @click="removeSize(sIndex)"></button>
            </th>
        <th :style="{ width:  'auto' }" class="text-center">TOTALE</th>
        </tr>

        </thead>


        <tbody>
          <tr @click="toggleZoom(vIndex)"
            v-for="(variant, vIndex) in variants"
            :key="variant.colorId"
            :class="{ 'row-zero': isRowAllZero(variant) , 'row-focused': focusedRow === vIndex }"
          >
            <!-- Numero riga + elimina -->
            <td class="sticky-col sticky-color">
              <button
                :disabled="getTotaleRiga(variant,1) > 0"
                title="Elimina riga"
                class="btn btn-light d-flex align-items-center gap-1"
                type="button"
                @click="confirmDelete(vIndex)"
              >
                {{ vIndex + 1 }}
                <i class="fas fa-trash-alt ml-2"></i>
              </button>
            </td>






            <!-- Colore -->
            <td class="sticky-col sticky-color">
            
              <div  class="input-group input-group-sm align-items-stretch">

                <v-select-colors
                  :disabled="getTotaleRiga(variant,1) > 0"
                  :colors="colors"
                  :required="true"
                  :key="variant.colorId + '-color-' + variant.vSelect"
                  :Id="variant.colorId"
                  :vIndex="vIndex"
                  :variants="variants"
                  class="flex-grow-1"
                  @update="setColor"
                  @setColors="setColors">

                </v-select-colors>

              </div>              

            </td>



            <!-- Supplier color -->
            <td class="sticky-col sticky-desc">
              <div class="input-group input-group-sm align-items-stretch">
                <input
                  :ref="'supplierColor-' + vIndex"
                  
                  type="text"
                  class="form-control form-control-sm"
                  v-model="variant.supplierColor"
                  placeholder="Inserisci colore fornitore"
                />

                
              </div>
            </td>

            <td class="text-center_">
                <div class="d-flex flex-column">
                <label  :class="{ 'highlight-label_ordered': focusedRow === vIndex && focusedType === 'ordered' }">

                  ORDINATO
                </label>
                <label  :class="{ 'highlight-label_delivered': focusedRow === vIndex && focusedType === 'delivered' }">
                  CONSEGNATO
                </label>
                </div>
            </td>


            

            <!-- Quantità per taglia -->
            <td
              v-for="(size, sIndex) in sizes"
              :key="size.sizeId"
              class="text-center qty-cell"
              :class="{ 'qty-zoomed_': activeRow === vIndex }"
              
            >

              <!-- QUANTITÀ ORDINATE -->
              <input
                required
                :min="0"
                :max="1000"
                type="number"
                class="form-control form-control-sm text-center input-full"
                v-model.number="variant.quantities[0][size.sizeId]"
                :ref="'qty-ordered-' + vIndex + '-' + sIndex"
                title="Quantità ordinata"

                  @focus="activeRow = vIndex,focusedType = 'ordered',focusedRow = vIndex"
                  @blur="activeRow = null,focusedType = null,focusedRow = null"

              />

              <!-- QUANTITÀ CONSEGNATE -->
              <input
                required
                :min="0"
                :max="1000"
                type="number"
                class="form-control form-control-sm text-center input-full mt-1 delivered-input"
                v-model.number="variant.quantities[1][size.sizeId]"
                :ref="'qty-delivered-' + vIndex + '-' + sIndex"
                title="Quantità consegnata"

                 @focus="activeRow = vIndex,focusedType = 'delivered',focusedRow = vIndex"
                 @blur="activeRow = null,focusedType = null,focusedRow = null"

              />

            </td>
            <td class="text-center"> 
              <div class="d-flex flex-column"> 
                <!-- Totale ordinate --> 
                <input type="number" class="bold1 form-control form-control-sm text-center mb-1" :value="getTotaleRiga(variant,0)" disabled title="Totale quantità ordinate" /> 
                
                <!-- Totale consegnate --> 
                <input 
                
                :class="{ 'border-red': getTotaleRiga(variant,0) !== getTotaleRiga(variant,1), 'border-black': getTotaleRiga(variant,0) === getTotaleRiga(variant,1) }"
                type="number" class="bold2 form-control form-control-sm text-center mb-1" :value="getTotaleRiga(variant,1)" disabled title="Totale quantità consegnate" /> 
                
              </div> 
            </td>



          </tr>
      </tbody>


       
        <tfoot>
          <tr class="font-weight-bold">
            <td></td>
            <td class="align-middle">
              <button type="button" class="btn btn-sm btn-info " @click="addVariant">
               <i style="color:yellow" class='fas fa-indent mr-2'></i>
              AGGIUNGI RIGA</button>
            </td>
            <td></td>
            <td></td>

            <td  v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center sticky-col" :style="{ width:  'auto' }">
              {{ size.size }}              
            </td>
            
           <td class="totalGeneral">
              <div class="d-flex justify-content-between">
                <span>TOT. ORDINATO</span>
                <strong>{{ totaliGenerali.ordinato }}</strong>
              </div>

              <div class="d-flex justify-content-between mt-1">
                <span>TOT. CONSEGNATO</span>
                <strong>{{ totaliGenerali.consegnato }}</strong>
              </div>
          </td>


            <!--<td v-for="size in sizes" class="text-center" :key="size.sizeId"></td>-->
            <!--<td class="text-right">{{ totalGeneral() }}</td> Totale generale di tutte le righe -->
          </tr>
        </tfoot>        
      </table>

  


<button :disabled="isSubmitDisabled"
        type="submit"
        class="btn btn-primary float-right mt-3 mr-4">
  <i class="fas fa-arrow-circle-right mr-2"></i>
  PROCEDI
</button>

</div>
  
</form>

</div>


<!--  PRICE LIST UPDATE  -->
<div v-else>
  
<priceUpFormUpdate @back="type='A'" @submit="confirmData" 
v-bind:variazioneListino="flagVariazioneListino"
v-bind:discounts="discounts"
v-bind:orderPrices="orderPricesList" v-bind:gridVariants="variants" v-bind:counter="counter" v-bind:productId="productId" ></priceUpFormUpdate>
    
</div>

    
    <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre>  </pre> 
      
    </div>
    
  </div>
</template>

<script>

import api                         from '@/api'

import productInfo                 from '@/components/product/ProductInfo.vue';

import sizesList                   from '@/components/order/SizesList.vue';
import VSelectColors               from '@/components/order/vSelectColors.vue';
import NewColor                    from '@/components/order/NewColorForm.vue';
import EAN                         from "@/utils/index.js";

import priceUpFormUpdate           from '@/components/order/PriceUpFormUpdate.vue';

import { mapGetters }              from 'vuex'


import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'

import { v4 as uuidv4 }            from 'uuid'

export default {
   props : ['productId','order'],
   components: {productInfo,sizesList,VSelectColors,NewColor,priceUpFormUpdate,modalMessage,modalConfirm},
  data() {
    return {

      type             : 'A',
      
      refresh          : true, 
     
      sizes            : [],      
      variants         : [],
      productBarcodes  : {},
      orderPricesList  : [],
      discounts        : [],
      focusedType      : null, // "ordered" o "delivered"
      focusedRow       : null,
      activeRow        : null,
      counter          : 0,
      //items                 : [],
      spinner               : false,
      msg                   : '',
      colors                : [],
      flagVariazioneListino : false,
      uuid                  : ''

      
      
      
    };
  },
   
    mounted()
    {
      this.getData()
    },
   created () 
    {
     
     
      this.uuid = uuidv4()
      
    },
computed: {

 ...mapGetters(['company']) , 


  isSubmitDisabled() {
  return (
    this.variants.length === 0 ||
    this.variants.every(variant =>
      variant.quantities.every(qObj =>
        Object.values(qObj).every(q => q === 0)
      )
    )
  );
},
totaliGenerali() 
{ 
  let totaleOrdinato = 0; let totaleConsegnato = 0; 
  this.variants.forEach(item => { 
    const ordinato = item.quantities[0]; 
    const consegnato = item.quantities[1]; 
    const sommaOrdinato = Object.values(ordinato).reduce((a, b) => a + Number(b), 0); 
    const sommaConsegnato = Object.values(consegnato).reduce((a, b) => a + Number(b), 0); 
    totaleOrdinato += sommaOrdinato; 
    totaleConsegnato += sommaConsegnato; 
  }); 
    return { ordinato: totaleOrdinato, consegnato: totaleConsegnato }; 
  }




},


  
  methods: {

    setColors(colors)
    {
      this.colors = colors
    },
    getTotaleRiga(variant,row)
    {
      const total = Object.values(variant.quantities[row]).reduce((a,b)=>a + (b || 0), 0)
      return total 
    },

  

    toggleZoom(index) {
        this.zoomedRow = this.zoomedRow === index ? null : index
      },


   fillMissingSizes (variants, sizes) {
    return variants.map(color => {
    const newQuantities = color.quantities.map(qtyObj => {
      // copio l'oggetto per non modificare l'originale
      const newQty = { ...qtyObj };

      // per ogni sizeId controlliamo se esiste, altrimenti aggiungiamo 0
      sizes.forEach(size => {
        if (!(size.sizeId in newQty)) 
        {
          newQty[size.sizeId] = 0;
        }
      });

      return newQty;
    });

    return {
      ...color,
      quantities: newQuantities
    };
  });
  },


    async getData()
    {
        
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'})    
        const sp       = 'spOrderDetailProductVariants' 
        const payload  = {'orderId' : this.order.orderId, 'productId' : this.productId,'companyId':this.company.Id,sp}
        
          try{

            const res = await api.post(payload)
              if (res.status !== 200) 
              {
                  throw new Error(res.data ||  res)
              }
                  this.$refs.msgModal.close()
                  this.variants              = res.data.recordsets[0][0]
                  this.sizes                 = res.data.recordsets[1][0]
                  this.productBarcodes       = res.data.recordsets[2][0]
                  this.orderPricesList       = res.data.recordsets[3][0]
                  this.colors                = res.data.recordsets[4]
                  this.flagVariazioneListino = res.data.recordsets[5].length > 0
                  this.discounts             = res.data.recordsets[6]  

                  /*  MAPPA A ZERO LE VARIANTI NON PRESENTI  */
                  const items          = this.fillMissingSizes(this.variants, this.sizes)
                  this.variants        = items
  


        }catch(err)
        {
          this.$refs.msgModal.show(err.message)
        }

        
        
       
    },

    async confirmData(data)
    {
  
         const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA SALVARE LA MODIFICA ORDINE ?',
          { title: 'CONFERMA MODIFICA' },1
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()
  
        this.saveOrder(data)

    },   

    async saveOrder(data)
    {
    
      
      try
      {
      
        const uuid     = this.uuid
        const sp       = 'spUpdateSupplierOrderDetailRequestLog'
        const payload  = {'orderId'               : this.order.orderId, 
                          'productId'             : this.productId,
                          'counter'               : this.counter,
                          ...data,
                         
                          uuid,sp}

        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},5)
        
        const res = await api.post(payload)
        
          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }

          /* =========================
              CONTROLLO RISPOSTA UUID
            ========================== */

           
            this.$emit('update')  
      }
      catch(err)
      {
         
          this.$refs.msgModal.show(err.message)
          
      }
          
       
    },

    getProductEAN13(productId, colorId, sizeId) {
      const item = this.productBarcodes.barcodes.find(
      b =>
      b.productId == productId &&
      b.colorId == colorId &&
      b.sizeId == sizeId
     );

       return item ? item.barcode : '';
    },

   
    generateAllBarcodes(productId,counter) 
    {
        let r = counter
        this.variants.forEach(variant => {
          if (!variant.barcodes) {
            this.$set(variant, "barcodes", {});
          }

          Object.keys(variant.quantities[0]).forEach(sizeId => 
          {

              const ean13   =  this.getProductEAN13(
                productId,
                variant.colorId,
                sizeId   // <-- QUI la chiave è il sizeId

            )

                      
            const barcode = ean13.length == 13 ? ean13 : EAN.createEAN13(productId,++r)  
            this.$set(variant.barcodes, sizeId, barcode);
          });
      })
      
      return r
    },



    isRowAllZero(variant) {
      const quantities = variant.quantities;
      return Object.values(quantities).every(q => Number(q) === 0);
    },

    submit() 
    {

      this.counter =  this.generateAllBarcodes(this.productBarcodes.productId,this.productBarcodes.counter);
      this.productBarcodes.counter = this.counter   
      /*  MOSTRA PriceUpFormUpdate */ 
      this.type = ''
    },

    /*
    sanitizeQuantity(variant, sizeId) {

        let value = variant.quantities[sizeId];
        // rimuove tutto ciò che non è numero
        value = String(value).replace(/\D+/g, '');
        this.$set(variant.quantities, sizeId, value ? Number(value) : 0);

    },
    */
    setColor(colorId,vIndex,color)
    {      
      this.variants[vIndex].colorId = colorId
      this.variants[vIndex].colore = color
      this.focusSupplierColor(vIndex)
    },

    setSizes(sizes) {
  
        this.sizes = sizes

        const updateQuantitiesFromSizes = (variant, sizes) => {
          // Creiamo due oggetti distinti:
          // 0 = ordinate, 1 = consegnate
          const newOrdered = {}
          const newDelivered = {}

          sizes.forEach(size => {
            const sizeId = size.sizeId

            // Quantità ordinate
            newOrdered[sizeId] =
              variant.quantities &&
              variant.quantities[0] &&
              variant.quantities[0][sizeId] !== undefined
                ? variant.quantities[0][sizeId]
                : 0

            // Quantità consegnate
            newDelivered[sizeId] =
              variant.quantities &&
              variant.quantities[1] &&
              variant.quantities[1][sizeId] !== undefined
                ? variant.quantities[1][sizeId]
                : 0
          })

            // Sostituzione completa → reattiva in Vue 2
            this.$set(variant, 'quantities', [newOrdered, newDelivered])
          }

            // Applica aggiornamento a tutte le varianti
            this.variants.forEach(variant => {
              updateQuantitiesFromSizes(variant, this.sizes)
            })

              const emptyObj = {retailPrice: 0,costPrice : 0,discount:0,discount2:0,discount3 : 0 }
             
              this.orderPricesList.prices = sizes.map(s => {
                const { sizeId, size } = s;
                const existing = this.orderPricesList.prices.find(o => o.sizeId === sizeId);

              return existing
                ? { ...existing }
                : { sizeId, size, ...emptyObj };
            });



        },

    
    
    onColorSelect(vIndex) {
    const variant = this.variants[vIndex]

    // focus automatico sulla prima misura
    this.focusFirstQuantity(vIndex)
  },  


     totalPerRow(variant) {
       
         return Object.values(variant.quantities).reduce((sum, q) => sum + (q || 0), 0);
         
      },
      /*
      totalPerSize(size) {
          return this.variants.reduce((sum, v) => sum + (v.quantities[size] || 0), 0);
      },
      */
      totalGeneral() {
        return this.variants.reduce((sum, v) => sum + this.totalPerRow(v), 0);
      },
    
      
    focusSupplierColor(rowIndex) {
    this.$nextTick(() => {
      //if (this.sizes.length === 0) return;

      const refName = 'supplierColor-' + rowIndex ;
      const ref = this.$refs[refName];

      // Vue 2.6: $refs può essere un array se ref è dentro v-for
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && input.focus) input.focus();
    });
    },
  

    focusFirstQuantity(rowIndex) {
    this.$nextTick(() => {
      if (this.sizes.length === 0) return;

      const refName = 'qty-' + rowIndex + '-0';
      const ref = this.$refs[refName];

      // Vue 2.6: $refs può essere un array se ref è dentro v-for
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && input.focus) input.focus();
    });
    },

  
    createEmptyVariant() {
        return {
          colorId: null,
          supplierColor: '',
          vSelect      : true,
          colore       : '',  
          quantities: [
            //  Quantità ORDINATE
            this.sizes.reduce((acc, s) => {
              acc[s.sizeId] = 0
              return acc
            }, {}),

            //  Quantità CONSEGNATE
            this.sizes.reduce((acc, s) => {
              acc[s.sizeId] = 0
              return acc
            }, {})
          ]
        }
    },


    addVariant() {
      
      this.variants.push(this.createEmptyVariant());
    },
    
 
    async confirmDelete(row) {

      const rowToDelete = row + 1
      const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA ELIMINARE LA RIGA   [ ' + rowToDelete  + ' ]  ?',
          { title: 'CONFERMA' },1
        )

      if (!confirmed) return  
      this.$refs.confirmModal.close()
      this.variants.splice(row, 1)   
      },

    validateQuantity(variant, size) {
      if (variant.quantities[size] < 0) variant.quantities[size] = 0;
    },

    fillColumn(size, value) {
      this.variants.forEach(variant => {
        this.$set(variant.quantities, size, value);
      });
    },

    
    replicateFirstRowQuantities() {
        if (!this.variants.length) return;

        const sourceQuantities = this.variants[0].quantities;

        this.variants.forEach((variant, index) => {
          if (index === 0) return;

          // copia PROFONDA + reattiva
          this.$set(variant, 'quantities', { ...sourceQuantities });
        });
    },


  
    /*
    totalPerSize(size) {
      return this.variants.reduce((sum, v) => sum + (v.quantities[size] || 0), 0);
    },
    */
  },
};
</script>

<style scoped>


.row-focused 
{
  background-color: #f3f7ff; /* leggero blu */
}

.highlight-label_ordered 
{ 
  /*color            : #007bff;*/
  text-decoration  : underline;
}

.highlight-label_delivered
{ 

  /*color            : #007bff;*/
  text-decoration  : underline;
}

.qty-cell {
  transition: all 0.2s ease;
}

.qty-zoomed input 
{
  font-size: 1.2rem;
  height: 38px;
  font-weight: 600;
}

.qty-zoomed 
{
  background: #fff;
}

.sticky-col,
.sticky-desc,
.row-index-cell {
  vertical-align: middle !important;
  text-align: center !important;
}

.row-index-cell button {
  margin: 0 auto;
}


.page-header {
  position: fixed;
  top: 50;
  left: 0;
  width: 100%;
  z-index: 1000; /* sopra Bootstrap navbar/table */
  background-color: #fff;
}

/* header */
thead th.sticky-col {
  z-index: 20;
  background: #28a745;
  color: white;
  border-color: white !important;
  border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */

}



/* footer */
tfoot td.sticky-col {
  z-index: 20;
  color : white;
  background: #28a745;
  border-color: white !important;
   border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
}

/* celle normali */
tbody td {
  background: #fff;
}



.vs__dropdown-menu {
  z-index: 1050; /* sopra Bootstrap modals */
}

button:hover {
   cursor        : pointer;
  }
.row-zero {
  background-color: #ffe6e6 !important;
}

.my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}

/*
.td-input 
{
  padding: 0 !important; 
}
*/


.input-full {
  /*
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
*/
  font-weight       : bold;  
}


.input-full:focus {
  outline      : none;
  border       : 3px solid #2846a7 !important;
  --box-shadow: 0 0 0 2px rgba(0,123,255,.25) !important;
}

/*
.td-input:focus-within {
  box-shadow: inset 0 0 0 3px #28a745;
}
*/

.delivered-input_ {
  background-color   : #e1e5e8;
  border-color       : #132643;
}

.bold1 {
  border: none;
  background-color: transparent;
  font-weight: bolder;
}

.bold2{
    
  font-weight: bolder;
}
.badge-pill
{
  font-size: large;
}


.border-red {
  border: 2px solid red;
}

.border-black {
  border: 2px solid black;
}
.totalGeneral{
  
  background-color: gainsboro;
  color:blue
  
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.fa-trash-alt{
  color      : #28a745 !important;
  font-size  : 18px;
}
</style>
